// ============================================
// PORTFOLIO DATA
// ============================================

export const portfolioData = {
  
  // Dates and topics as printed on each MySkill certificate. `thumb` is a 640px WebP for the grid.
  certificates: [
    {
      id: 1,
      title: "AI for Content Marketing",
      issuer: "MySkill",
      date: "2025-12-08",
      topic: "ai",
      image: "/certificates/AI FOR CONTENT MARKETING.png",
      thumb: "/certificates/thumbs/AI FOR CONTENT MARKETING.webp",
    },
    {
      id: 2,
      title: "AI for Software Engineer",
      issuer: "MySkill",
      date: "2025-12-08",
      topic: "ai",
      image: "/certificates/AI FOR SOFTWARE ENGINEER.png",
      thumb: "/certificates/thumbs/AI FOR SOFTWARE ENGINEER.webp",
    },
    {
      id: 3,
      title: "AI for Spreadsheets",
      issuer: "MySkill",
      date: "2025-12-08",
      topic: "ai",
      image: "/certificates/AI FOR SPREADSHEETS.png",
      thumb: "/certificates/thumbs/AI FOR SPREADSHEETS.webp",
    },
    {
      id: 4,
      title: "Artificial Intelligence Introduction",
      issuer: "MySkill",
      date: "2025-12-08",
      topic: "ai",
      image: "/certificates/ARTIFICIAL INTELLIGENCE INTRODUCTION.png",
      thumb: "/certificates/thumbs/ARTIFICIAL INTELLIGENCE INTRODUCTION.webp",
    },
    {
      id: 5,
      title: "Maximizing the Use of AI Tools",
      issuer: "MySkill",
      date: "2025-12-08",
      topic: "ai",
      image: "/certificates/MAXIMIZING THE USE OF AI TOOLS.png",
      thumb: "/certificates/thumbs/MAXIMIZING THE USE OF AI TOOLS.webp",
    },
    {
      id: 6,
      title: "Maximizing the Use of ChatGPT",
      issuer: "MySkill",
      date: "2025-12-08",
      topic: "ai",
      image: "/certificates/MAXIMIZING THE USE OF CHATGPT.png",
      thumb: "/certificates/thumbs/MAXIMIZING THE USE OF CHATGPT.webp",
    },
    {
      id: 7,
      title: "Note-Taking Using AI",
      issuer: "MySkill",
      date: "2025-12-08",
      topic: "ai",
      image: "/certificates/NOTE-TAKING USING AI.png",
      thumb: "/certificates/thumbs/NOTE-TAKING USING AI.webp",
    },
    {
      id: 8,
      title: "Introduction to CSS",
      issuer: "MySkill",
      date: "2025-10-12",
      topic: "web",
      image: "/certificates/INTRODUCTION TO CSS.png",
      thumb: "/certificates/thumbs/INTRODUCTION TO CSS.webp",
    },
    {
      id: 9,
      title: "CSS Box Model",
      issuer: "MySkill",
      date: "2025-10-12",
      topic: "web",
      image: "/certificates/CSS BOX MODEL 1.png",
      thumb: "/certificates/thumbs/CSS BOX MODEL 1.webp",
    },
    {
      id: 10,
      title: "Internet Introduction",
      issuer: "MySkill",
      date: "2025-10-12",
      topic: "web",
      image: "/certificates/INTERNET INTRODUCTION.png",
      thumb: "/certificates/thumbs/INTERNET INTRODUCTION.webp",
    },
  ],

  // `usedIn` lists GitHub repos (under Dans-Vsa) that actually use the tool.
  techStack: [
    {
      id: 1,
      name: "React",
      icon: "FaReact",
      color: "#61DAFB",
      category: "Frontend",
      usedIn: ['my-portofolio', 'habitloop', 'MedicalSystem'],
    },
    {
      id: 2,
      name: "Tailwind CSS",
      icon: "SiTailwindcss",
      color: "#06B6D4",
      category: "Frontend",
      usedIn: ['my-portofolio', 'Foodstall-System', 'MedicalSystem'],
    },
    {
      id: 3,
      name: "Bootstrap",
      icon: "FaBootstrap",
      color: "#7952B3",
      category: "Frontend",
      usedIn: [],
    },
    {
      id: 4,
      name: "JavaScript",
      icon: "SiJavascript",
      color: "#F7DF1E",
      category: "Language",
      usedIn: ['legenda-lembah-angin', 'PortoGameLab', 'fujimoto-archive', 'look-back'],
    },
    {
      id: 5,
      name: "HTML5",
      icon: "FaHtml5",
      color: "#E34F26",
      category: "Language",
      usedIn: ['fujimoto-archive', 'chainsaw-man-fanblog', 'look-back', 'niwatori-fanblog'],
    },
    {
      id: 6,
      name: "CSS3",
      icon: "FaCss3Alt",
      color: "#1572B6",
      category: "Language",
      usedIn: ['fujimoto-archive', 'chainsaw-man-fanblog', 'look-back'],
    },
    {
      id: 7,
      name: "Python",
      icon: "FaPython",
      color: "#3776AB",
      category: "Language",
      usedIn: ['spendwise-api', 'gitpulse', 'gesture-pilot', 'dupesweep'],
    },
    {
      id: 8,
      name: "Java",
      icon: "FaJava",
      color: "#E76F00",
      category: "Language",
      usedIn: ['Game-PlatypusD', 'Game-ALIENKI'],
    },
    {
      id: 9,
      name: "Node.js",
      icon: "FaNodeJs",
      color: "#339933",
      category: "Backend",
      usedIn: [],
    },
    {
      id: 10,
      name: "PHP",
      icon: "FaPhp",
      color: "#777BB4",
      category: "Backend",
      usedIn: ['Foodstall-System', 'PFW-InstalBreeze-JetSream'],
    },
    {
      id: 11,
      name: "Laravel",
      icon: "FaLaravel",
      color: "#FF2D20",
      category: "Backend",
      usedIn: ['Foodstall-System', 'PFW-InstalBreeze-JetSream'],
    },
    {
      id: 12,
      name: "FastAPI",
      icon: "SiFastapi",
      color: "#009688",
      category: "Backend",
      usedIn: ['spendwise-api'],
    },
    {
      id: 13,
      name: "MySQL",
      icon: "SiMysql",
      color: "#4479A1",
      category: "Database",
      usedIn: ['Foodstall-System'],
    },
    {
      id: 14,
      name: "SQLite",
      icon: "SiSqlite",
      color: "#003B57",
      category: "Database",
      usedIn: ['spendwise-api', 'dupesweep'],
    },
    {
      id: 15,
      name: "MongoDB",
      icon: "SiMongodb",
      color: "#47A248",
      category: "Database",
      usedIn: [],
    },
    {
      id: 16,
      name: "Godot Engine",
      icon: "SiGodotengine",
      color: "#478CBF",
      category: "Game",
      usedIn: ['kopi-tycoon', 'legenda-lembah-angin'],
    },
    {
      id: 17,
      name: "Figma",
      icon: "FaFigma",
      color: "#F24E1E",
      category: "Design",
      usedIn: ['MedicalSystem'],
    },
    {
      id: 18,
      name: "Git",
      icon: "FaGitAlt",
      color: "#F05032",
      category: "Tools",
      usedIn: [],
    },
    {
      id: 19,
      name: "VS Code",
      icon: "FaCode",
      color: "#007ACC",
      category: "Tools",
      usedIn: [],
    },
    {
      id: 20,
      name: "Docker",
      icon: "FaDocker",
      color: "#2496ED",
      category: "Tools",
      usedIn: ['spendwise-api'],
    },
    {
      id: 21,
      name: "Vite",
      icon: "SiVite",
      color: "#646CFF",
      category: "Tools",
      usedIn: ['my-portofolio', 'habitloop', 'Foodstall-System', 'MedicalSystem'],
    },
    {
      id: 22,
      name: "TypeScript",
      icon: "SiTypescript",
      color: "#3178C6",
      category: "Language",
      usedIn: ['habitloop', 'MedicalSystem'],
    },
  ],

  // Ordered by weight. `kind` drives the primary button: game -> play, web -> visit, code -> GitHub only.
  // `video` is a short muted demo recorded from the live build; `poster` is shown until it plays.
  projects: [
    {
      id: 'legenda',
      title: 'Legenda Lembah Angin',
      kind: 'game',
      description: {
        en: 'Turn-based RPG with an Active Time Battle system that runs in the browser. Three heroes, elemental weaknesses, burst skills, a boss fight and saves, with all pixel art and chiptune music generated in code.',
        id: 'RPG turn-based dengan sistem Active Time Battle yang jalan di browser. Tiga pahlawan, kelemahan elemen, jurus burst, pertarungan bos, dan fitur simpan. Semua pixel art dan musik chiptune dibuat lewat kode.',
      },
      tags: ['JavaScript', 'Canvas', 'Godot 4'],
      video: '/projects/legenda.webm',
      poster: '/projects/legenda.webp',
      liveLink: 'https://dans-vsa.github.io/legenda-lembah-angin/',
      githubLink: 'https://github.com/Dans-Vsa/legenda-lembah-angin',
    },
    {
      id: 'kopi-tycoon',
      title: 'Kopi Tycoon',
      kind: 'game',
      description: {
        en: 'Idle clicker about growing a coffee shop, built with Godot 4. Six generators, upgrades, prestige, offline earnings and a café scene that fills up as the business grows.',
        id: 'Game idle clicker tentang membesarkan kedai kopi, dibuat dengan Godot 4. Enam generator, upgrade, prestige, penghasilan offline, dan suasana kafe yang makin ramai seiring bisnis tumbuh.',
      },
      tags: ['Godot 4', 'GDScript', 'Web export'],
      video: '/projects/kopi.webm',
      poster: '/projects/kopi.webp',
      liveLink: 'https://dans-vsa.github.io/kopi-tycoon/',
      githubLink: 'https://github.com/Dans-Vsa/kopi-tycoon',
    },
    {
      id: 'porto-game-lab',
      title: 'PortoGameLab',
      kind: 'game',
      description: {
        en: 'A portfolio you explore as a game. Walk a research lab, scan exhibits, collect research data and achievements, with a minimap and a bilingual UI.',
        id: 'Portofolio yang dijelajahi seperti game. Berjalan di laboratorium riset, scan exhibit, kumpulkan research data dan achievement, lengkap dengan minimap dan UI dua bahasa.',
      },
      tags: ['JavaScript', 'Canvas', 'Game design'],
      video: '/projects/gamelab.webm',
      poster: '/projects/gamelab.webp',
      liveLink: 'https://dans-vsa.github.io/PortoGameLab/',
      githubLink: 'https://github.com/Dans-Vsa/PortoGameLab',
    },
    {
      id: 'habitloop',
      title: 'habitloop',
      kind: 'web',
      description: {
        en: 'Local-first habit tracker with streaks, weekly goals, year heatmaps and an insights dashboard. Installable PWA that works offline, with JSON backup and keyboard shortcuts.',
        id: 'Pelacak kebiasaan local-first dengan streak, target mingguan, heatmap setahun, dan dashboard insight. PWA yang bisa diinstal dan jalan offline, lengkap dengan backup JSON dan shortcut keyboard.',
      },
      tags: ['React', 'TypeScript', 'PWA'],
      video: '/projects/habitloop.webm',
      poster: '/projects/habitloop.webp',
      liveLink: 'https://dans-vsa.github.io/habitloop/',
      githubLink: 'https://github.com/Dans-Vsa/habitloop',
    },
    {
      id: 'fujimoto-archive',
      title: 'Fujimoto Archive',
      kind: 'web',
      description: {
        en: 'Fan archive of every Tatsuki Fujimoto work with nine companion sites, from Chainsaw Man, Look Back and Fire Punch to the one-shots Love is Blind, Sasaki Stopped a Bullet and Niwatori.',
        id: 'Arsip fan semua karya Tatsuki Fujimoto dengan sembilan situs pendamping, dari Chainsaw Man, Look Back, dan Fire Punch sampai one-shot Love is Blind, Sasaki Stopped a Bullet, dan Niwatori.',
      },
      tags: ['JavaScript', { en: '10 sites', id: '10 situs' }, 'ID/EN'],
      video: '/projects/fujimoto.webm',
      poster: '/projects/fujimoto.webp',
      liveLink: 'https://dans-vsa.github.io/fujimoto-archive/',
      githubLink: 'https://github.com/Dans-Vsa/fujimoto-archive',
    },
    {
      id: 'spendwise-api',
      title: 'SpendWise API',
      kind: 'code',
      description: {
        en: 'REST API for personal finance with JWT auth, transactions, monthly budgets, reports and CSV import/export. Tested with pytest and shipped with Docker and CI.',
        id: 'REST API keuangan pribadi dengan autentikasi JWT, transaksi, anggaran bulanan, laporan, serta impor/ekspor CSV. Diuji dengan pytest, siap Docker, dan memakai CI.',
      },
      tags: ['FastAPI', 'SQLAlchemy', 'Docker'],
      video: '/projects/spendwise.webm',
      poster: '/projects/spendwise.webp',
      liveLink: null,
      githubLink: 'https://github.com/Dans-Vsa/spendwise-api',
    },
    {
      id: 'gesture-pilot',
      title: 'gesture-pilot',
      kind: 'code',
      description: {
        en: 'Control your computer with hand gestures from a webcam. Real-time MediaPipe hand tracking, rule-based and trainable gesture recognition, and TOML-configured actions for media, mouse and keys.',
        id: 'Kendalikan komputer dengan gerakan tangan lewat webcam. Hand tracking MediaPipe real-time, pengenalan gesture berbasis aturan maupun yang bisa dilatih, dan aksi media, mouse, serta keyboard yang diatur lewat TOML.',
      },
      tags: ['Python', 'MediaPipe', 'OpenCV'],
      video: '/projects/gesture-pilot.webm',
      poster: '/projects/gesture-pilot.webp',
      liveLink: null,
      githubLink: 'https://github.com/Dans-Vsa/gesture-pilot',
    },
    {
      id: 'gitpulse',
      title: 'gitpulse',
      kind: 'code',
      description: {
        en: 'Terminal analytics for git repositories: contributors, churn hotspots and activity heatmaps, exportable to JSON, CSV or Markdown.',
        id: 'Analitik terminal untuk repositori git: kontributor, hotspot perubahan, dan heatmap aktivitas, bisa diekspor ke JSON, CSV, atau Markdown.',
      },
      tags: ['Python', 'CLI', 'Rich'],
      video: '/projects/gitpulse.webm',
      poster: '/projects/gitpulse.webp',
      liveLink: null,
      githubLink: 'https://github.com/Dans-Vsa/gitpulse',
    },
    {
      id: 'dupesweep',
      title: 'dupesweep',
      kind: 'code',
      description: {
        en: 'Dependency-free CLI that finds duplicate files by size and content hash, then safely quarantines, hard-links or deletes the extra copies, with a dry run by default and an undo log.',
        id: 'CLI tanpa dependensi untuk menemukan file duplikat lewat ukuran dan hash isi, lalu memindahkan, meng-hard-link, atau menghapus salinannya dengan aman. Dry run secara default dan ada log undo.',
      },
      tags: ['Python', 'CLI', 'SQLite'],
      video: '/projects/dupesweep.webm',
      poster: '/projects/dupesweep.webp',
      liveLink: null,
      githubLink: 'https://github.com/Dans-Vsa/dupesweep',
    },
  ],

};
